/**
 * Standalone SHARED_IMPORTS export — no workflow-module dependencies.
 * Import from here (not shared-providers) when circular-dependency issues arise.
 * shared-providers.ts re-exports this for backward compatibility.
 */
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {
  CmAccessModuleModule,
  CmUiBasicsModule,
  CmUiColorPickerModule,
  CmUiCompoundFilterModule,
  CmUiContentCardComponent,
  CmUiContentComponent,
  CmUiFormModule,
  CmUiLoaderModule,
  CmUiNavbarModule,
  CmUiTableContainerComponent,
  CmUiTableModule,
  UiTopBarModule,
} from '@cm/ui-modules';
import { TranslateModule } from '@ngx-translate/core';
import * as fromComponents from './components';
export * from './components';

export const MATERIAL_MODULES = [
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
];

export const CM_UI_MODULES = [
  CmUiTableModule,
  CmUiNavbarModule,
  CmUiFormModule,
  UiTopBarModule,
  CmUiCompoundFilterModule,
  CmUiLoaderModule,
  CmAccessModuleModule,
  CmUiBasicsModule,
  CmUiColorPickerModule,
];

export const SHARED_IMPORTS = [
  CommonModule,
  RouterModule,
  ...MATERIAL_MODULES,
  ...CM_UI_MODULES,
  TranslateModule,
  FormsModule,
  ReactiveFormsModule,
  CmUiTableContainerComponent,
  CmUiContentComponent,
  CmUiContentCardComponent,
  ...fromComponents.components,
];
